import { useEffect, useRef, useState } from "react";

export const useScrollIndicator = (dependencies: any[] = []) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  const checkScrollable = () => {
    if (scrollContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        scrollContainerRef.current;
      const hasScrollableContent = scrollHeight > clientHeight;
      const isNotAtBottom = scrollTop + clientHeight < scrollHeight - 5;
      setShowScrollIndicator(hasScrollableContent && isNotAtBottom);
    }
  };

  const scrollToBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const handleScroll = () => {
        checkScrollable();
      };

      scrollContainer.addEventListener("scroll", handleScroll);

      const observer = new MutationObserver(() => {
        checkScrollable();
      });

      observer.observe(scrollContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      const timeoutId = setTimeout(checkScrollable, 100);

      const handleResize = () => checkScrollable();
      window.addEventListener("resize", handleResize);

      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
        observer.disconnect();
        clearTimeout(timeoutId);
      };
    }
  }, dependencies);

  useEffect(() => {
    const timeoutId1 = setTimeout(checkScrollable, 100);
    const timeoutId2 = setTimeout(checkScrollable, 500);

    return () => {
      clearTimeout(timeoutId1);
      clearTimeout(timeoutId2);
    };
  }, dependencies);

  return {
    scrollContainerRef,
    showScrollIndicator,
    scrollToBottom,
  };
};
